import React from 'react';
import RoadVariantIcon from 'mdi-react/RoadVariantIcon';
import PackageVariantClosedIcon from 'mdi-react/PackageVariantClosedIcon';

import ItemNavLink from 'domain/fuse/preferences/DynamicNavLink/ItemNavLink';
import { ROUTES } from './constants';

const Sidebar = (props) => {
  const {
    isAllowedMenuItem,
    authorities,
    classes,
    toggleDrawer,
    isSidebarItemActive,
    titleMapping,
    open,
  } = props;

  return (
    <>
      {isAllowedMenuItem('ORDERS', authorities) && (
        <ItemNavLink
          classes={classes}
          titleMapping={titleMapping}
          toggleDrawer={toggleDrawer}
          isSidebarItemActive={isSidebarItemActive}
          open={open}
          toUrl="/orders"
          itemKey="orders"
          iconComponent={<PackageVariantClosedIcon />}
          groupTitle="shipping"
        />
      )}
    </>
  );
};

export default Sidebar;
